import React, { useState } from "react";
import { Box, Button } from "@material-ui/core";
import { FilterList } from "@material-ui/icons";

import Container from "./components/Container";
import ThemeProvider from "./components/ThemeProvider";
import AccessBlockingsList from "./components/AccessBlockingsList";
import useAccessBlockings from "./hooks/useAccessBlockings";
import CreateAccessBlockingModal from "./components/CreateAccessBlockingModal";
import AccessBlockingsFilters from "./components/AccessBlockingsFilters";

export default function AccessBlockings() {
  const {
    accessBlockings,
    loading,
    limit,
    page,
    filters,
    nextPage,
    prevPage,
    refreshData,
    changePage,
    changeLimit,
    onClearFilters,
    onSubmitFilters
  } = useAccessBlockings();

  const [openModal, setOpenModal] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  }

  const handleSubmitFilters = (filters) => {
    setOpenFilters(false);
    onSubmitFilters(filters);
  }

  const handleClearFilters = () => {
    setOpenFilters(false);
    onClearFilters();
  }

  return (
    <ThemeProvider>
      <Container>
        <Box mt={2} mb={2} display="flex" justifyContent="space-between">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenFilters(prev => !prev)}
          >
            <FilterList />
            Filtros
          </Button>
          <Button variant="contained" color="primary" onClick={() => setOpenModal(true)}>Criar novo bloqueio</Button>
        </Box>
        <AccessBlockingsFilters
          open={openFilters}
          onSubmitFilters={handleSubmitFilters}
          onClearFilters={handleClearFilters}
          filters={filters}
        />
        <AccessBlockingsList
          accessBlockings={accessBlockings}
          loading={loading}
          limit={limit}
          page={page}
          changeLimit={changeLimit}
          nextPage={nextPage}
          prevPage={prevPage}
          changePage={changePage}
          refreshData={refreshData}
        />
      </Container>
      {openModal && (
        <CreateAccessBlockingModal
          open={openModal}
          onClose={handleCloseModal}
          refreshData={refreshData}
        />
      )}
    </ThemeProvider>
  );
}
